import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import { iconComponentNameMap, IconSlug } from './iconMap'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppIcon',
  props: {
  iconId: null,
  icon: null,
  size: { default: 24 },
  variant: null,
  direction: null,
  fill: null
},
  emits: ["click"],
  setup(__props, { emit }) {

const props = __props;



const iconComponentName = computed(() => iconComponentNameMap[props.icon]?.())



return { __sfc: true,props, iconComponentName, emit }
}

})